import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
}
export function CTAButton({
  children,
  className = ''
}: CTAButtonProps) {
  return <div className="flex flex-col items-center justify-center w-full" data-id="element-6">
      <a href="#compra" className={`
          relative group flex items-center justify-center gap-2
          w-full md:max-w-2xl px-6 py-4 md:py-5
          bg-[#22c55e] hover:bg-[#16a34a]
          text-white text-center
          rounded-lg shadow-xl hover:shadow-2xl
          transform transition-all duration-200 hover:-translate-y-1
          border-b-4 border-[#15803d] active:border-b-0 active:translate-y-1
          text-xl md:text-2xl font-bold uppercase tracking-wide
          ${className}
        `} data-id="element-7">
        {children}
        <ArrowRightIcon className="w-6 h-6 md:w-7 md:h-7" data-id="element-8" />
      </a>
    </div>;
}